var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "navbar" }, [
    _c("div", { staticClass: "navbar-brand" }, [
      _c("a", { staticClass: "navbar-item" }),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _c(
            "RouterLink",
            {
              staticClass: "button is-success is-outlined",
              attrs: { "active-class": "is-active", to: { name: "SignUp" } }
            },
            [_vm._v("\n        regístrate\n      ")]
          ),
          _c(
            "RouterLink",
            {
              staticClass: "button is-primary is-outlined is-inverted",
              attrs: { "active-class": "is-active", to: { name: "SignIn" } }
            },
            [_vm._v("\n        inicia sesión\n      ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }